module.exports = __webpack_public_path__ + "images/emoji/notebook_with_decorative_cover.6a0ee40b747db1ad3dae.png";